// type
export const TYPE_ACCOUNT = 'account'
export const TYPE_EMAIL = 'email'
export const TYPE_EMAIL_VCODE = 'vcode'
export const TYPE_PHONE = 'phone'
export const TYPE_PASSWORD = 'password'
export const TYPE_PASSWORD_VERIFY = 'verify_password'